export const TEXT_MAX_LINES = 5;
export const TEXT_MAX_LENGTH = 100;
export const PLACES_API_KEY = "AIzaSyA90B3nhr0fRYlglzxYqoJuXGretSAS9Gw";
